export default __webpack_public_path__ + "static/media/About4.3aca7acd.png";